import type { Host } from '../../store/types'

// Plaintext-trust warning for the connection-authorize flow
// (docs/secret-exposure-model.md). A credential is envelope-encrypted to the
// host it's stored on and is decryptable there, so if that host's owner isn't
// the signed-in user, they can read the plaintext value. This returns the
// confirm-to-proceed message when that's the case, or null when there's nothing
// to warn about (your own host, or an unknown owner — don't cry wolf).
export function foreignHostWarning(
  host: Host | undefined,
  currentHumanUserID: string | null,
): string | null {
  const owner = host?.owner_human_user_id
  // No owner info (older server / not joined) or it's your own host → no warning.
  if (!owner || !currentHumanUserID || owner === currentHumanUserID) return null
  const ownerName = host?.owner_name?.trim() || 'another household member'
  const hostName = host?.hostname || host?.host_id || 'that host'
  return (
    `"${hostName}" is owned by ${ownerName}.\n\n` +
    `The credential you're connecting will be stored decryptable on that host, so ${ownerName} can read its plaintext value. A secret is only usable where it's decrypted, and that machine's owner controls it.\n\n` +
    `Connect on ${ownerName}'s host anyway?`
  )
}
